export const RYO_WORLD_ADDRESS =
  "0x26065106fa319c3981618e7567480a50132f23932226a51c219ffb8e47daa84";
export const ETH_CONTRACT_ADDRESS =
  "0x49d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7";
